export const EmailFields = [
  {
    name: "email",
    label: "Email",
    type: "email",
    placeholder: "Enter your email",
  },
];

export const OtpFields = [
  {
    name: "otp",
    label: "OTP",
    type: "text",
    placeholder: "Enter 6-digit OTP",
    maxLength: 6,
  },
];

export const PasswordFields = [
  {
    name: "newPassword",
    label: "New Password",
    type: "password",
  },
  {
    name: "confirmPassword",
    label: "Confirm Password",
    type: "password",
  },
];

export default EmailFields;